export default __webpack_public_path__ + "static/static2-img3-5536f2a15e1f16f74e805a7bea4a3501.jpg";